import UsuarioRolPage from './UsuarioRolPage';

export default UsuarioRolPage;
